/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthCardNumber
 */
export interface HealthCardNumber {
    /**
     * 
     * @type {string}
     * @memberof HealthCardNumber
     */
    province: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCardNumber
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof HealthCardNumber
     */
    version?: string;
}

/**
 * Check if a given object implements the HealthCardNumber interface.
 */
export function instanceOfHealthCardNumber(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "province" in value;
    isInstance = isInstance && "number" in value;

    return isInstance;
}

export function HealthCardNumberFromJSON(json: any): HealthCardNumber {
    return HealthCardNumberFromJSONTyped(json, false);
}

export function HealthCardNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthCardNumber {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'province': json['province'],
        'number': json['number'],
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function HealthCardNumberToJSON(value?: HealthCardNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'province': value.province,
        'number': value.number,
        'version': value.version,
    };
}

